<template>
  <div class="cxm-ProgressLabelBar-Container">
    <ProgressLabelBarItem
      v-for="(item, i) in items"
      :key="i"
      :item="item"
      data-testid="progresslabelbar-baritem"
    />
  </div>
</template>

<script>
import ProgressLabelBarItem from './ProgressLabelBarItem.vue';

export default {
  name: 'ProgressLabelBar',
  components: {
    ProgressLabelBarItem,
  },
  props: {
    payload: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    items() {
      return this.payload.filter((item) => !item.extra);
    },
  },
};
</script>

<style lang="scss" scoped>
.cxm-ProgressLabelBar-Container {
  width: 100%;
  height: var(--track-spacing-sm);
  display: flex;
  gap: 1px;
  flex-direction: column;
  flex-wrap: wrap;
}
</style>
